export const SET_VIDEO = 'SET_VIDEO';
export const CLEAR_VIDEO = 'CLEAR_VIDEO';

export function setVideo(mp4) {
  return {
    type: SET_VIDEO,
    mp4: mp4
  };
}

export function clearVideo() {
  return { type: CLEAR_VIDEO };
}
